import { createFileRoute } from "@tanstack/react-router";
import { useSuspenseQuery } from "@tanstack/react-query";
import { suspenseOptions } from "@/lib/suspense-query";
import ErrorText from "@/components/universal/error-text";
import { getGetProductQueryOptions } from "@/requests/gen/react-query/product";
import ProductCard from "@/components/product-cards/product-card";
import { ProductCrumbs } from "../-crumbs";
import ProductTabs from "./-tabs";
import numericId from "@/lib/numeric-id";

export const Route = createFileRoute(
  "/_private/_patient-pharmcy-360/product/$productId/",
)({
  loader: ({ context: { queryClient }, params: { productId } }) =>
    queryClient.ensureQueryData(
      getGetProductQueryOptions(numericId(productId)),
    ),
  component: ProductDetailsPage,
});

function ProductDetailsPage() {
  const { productId } = Route.useParams();
  const {
    data: product,
    error,
    refetch,
  } = useSuspenseQuery(
    suspenseOptions(getGetProductQueryOptions(numericId(productId))),
  );

  const tabs = product ? <ProductTabs product={product} /> : null;

  return (
    <div>
      <title>{`${product?.catalog_product.product_base.name} - Legrande Health Portal`}</title>
      <ProductCrumbs />

      {error && <ErrorText text="Failed to load product details" />}
      {product && (
        <div className="grid gap-6 xl:grid-cols-2 *:min-w-0">
          <div className={tabs ? undefined : "col-span-2 max-w-150 mx-auto"}>
            <ProductCard product={product} refetch={refetch} />
          </div>
          {tabs}
        </div>
      )}
    </div>
  );
}
